
<div class="col-md-12 mt-5">
  <form [formGroup]="LTMDOCForm" (ngSubmit)="onSubmit()">
    Thank you for visiting the Fix My Claim portal for the Nelnet Data Security Settlement.<br /><br />
    Hello <span style="font-weight:bold; color:red">{{ LTMDOCForm.get('name')?.value }}</span>. We have processed the Claim Form you submitted
    regarding the consolidated class action settlement, <i>In re Data Security Cases Against Nelnet Servicing, LLC</i>. This letter is to inform you
    Claim Form is incomplete, and there is information necessary to validate your Claim.<br /><br />

    <!--<b>Flag - HTI</b><br />-->
    You selected Cash Payment for Lost Time, and were asked to specify your total requested reimbursement and attach a description of your
    actions taken in response to the Data Security Incident and the time associated with each action.<br /><br />

    To support your Claim, please provide a description of your actions taken in response to the Data Security Incident and the time
    associated with each action.<br /><br />

    Please use the browse option, by clicking on “Select Files” in the box below, to upload your supporting
    documentation being submitted to verify all of your positions and transactions.
    <br />
    <br />
    <div class="row mt-4">
      <div class="col-md-12">
        <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
        <label for="file" class="btn btn-primary btn-sm">Select files</label>
        <br />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <table class="table" #listofFiles>
          <thead>
            <tr>
              <th class="hidden">Id</th>
              <th>Files To Be Uploaded</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sd of supportingDocuments; let i = index">
              <td class="hidden">{{i}}</td>
              <td>{{sd.name}}</td>
              <td>
                <button type="button" class="btn btn-danger" (click)="removeRow(i)">Remove</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="showDivFileUploadMessage == true" style="color:red; font-size:1.1em; font-weight:bold">
          You must upload the required documents to submit.
        </div>
      </div>
    </div>
    <br />
    <br />
    <!--<div class="row rowformat">
      <div class="col-md-12">
        <div class="form-group">
          <label for="signature"><b>Signature of Claimant:</b><span style="color:red" class="required"> *</span></label>
          <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                 trim="blur" [ngClass]="{ 'is-invalid': f.signature.errors }" />
          <div *ngIf="f.signature.errors" class="invalid-feedback">
            <div *ngIf="f.signature.errors.required">This field is required</div>
            <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
            <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
            <div *ngIf="f.signature.errors.pattern">
              Only use letters, numbers, periods, spaces, hyphens,
              brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <ul class="list-inline text-center">
      <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
    </ul>
  </form>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)"
               size="medium"
               color="#fff"
               type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</div>
